import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { loadAiPanel } from '@capital-access/ai-panel';
import { CommonLazyLoadingService } from '@capital-access/common/lazy-loading';
import { AI_PANEL_MODULE_ID, LOAD_AI_PANEL_MODULE } from './ai-panel-module-id.model';

@Injectable()
export class AiPanelEffects {
  loadAiPanel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAiPanel),
      switchMap(() =>
        this.commonLazyLoadingService
          .loadModule(AI_PANEL_MODULE_ID, LOAD_AI_PANEL_MODULE)
          .pipe(map(moduleRef => moduleRef.instance.openAiPanel()))
      )
    )
  );

  constructor(private actions$: Actions, private commonLazyLoadingService: CommonLazyLoadingService) {}
}
